import { __read, __spreadArray } from "tslib";
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/ban-types */
import { isFunction, hookMethodDangerously } from '@slardar/sdk-template';
import { normalize } from './util';
var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'ChannelMergerNode',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'MessagePort',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
var DEFAULT_TIME_FUNCTION = ['setTimeout', 'setInterval', 'requestAnimationFrame', 'requestIdleCallback'];
var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
var ADD_EVENT_LISTENER = 'addEventListener';
var REMOVE_EVENT_LISTENER = 'removeEventListener';
export var hookeGlobalAsync = function (report) {
    var enabled = true;
    var wrap = function (fn) {
        if (!isFunction(fn))
            return fn;
        return (fn._w_ || (fn._w_ = function () {
            try {
                // NOTE: If you are a Slardar user, and you are seeing this stack frame, it
                //       means the Slardar SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with Slardar SDK.
                return (fn.handleEvent || fn).apply(this, [].map.call(arguments, wrap));
            }
            catch (e) {
                enabled && report(normalize(e));
                throw e;
            }
        }));
    };
    DEFAULT_TIME_FUNCTION.forEach(function (timeFunc) {
        return window[timeFunc] &&
            hookMethodDangerously(window, timeFunc, function (origin) {
                return function (handler) {
                    var params = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        params[_i - 1] = arguments[_i];
                    }
                    return origin && origin.call.apply(origin, __spreadArray([this, wrap(handler)], __read(params), false));
                };
            })();
    });
    hookMethodDangerously(XMLHttpRequest.prototype, 'send', function (origin) {
        return function () {
            var _this = this;
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            xmlHttpRequestProps.forEach(function (prop) { return _this[prop] && hookMethodDangerously(_this, prop, wrap)(); });
            return origin.apply(this, params);
        };
    })();
    DEFAULT_EVENT_TARGET.forEach(function (target) {
        var proto = window[target] && window[target].prototype;
        if (!proto || !proto[ADD_EVENT_LISTENER]) {
            return;
        }
        hookMethodDangerously(proto, ADD_EVENT_LISTENER, function (origin) {
            return function (evName, fn, options) {
                try {
                    var handleEventFn = fn.handleEvent;
                    if (isFunction(handleEventFn)) {
                        fn.handleEvent = wrap(handleEventFn);
                    }
                }
                catch (_a) {
                    //
                }
                return origin && origin.call(this, evName, wrap(fn), options);
            };
        })();
        hookMethodDangerously(proto, REMOVE_EVENT_LISTENER, function (origin) {
            return function (eventName, fn, options) {
                if (fn === null || fn === void 0 ? void 0 : fn._w_) {
                    origin.call(this, eventName, fn._w_, options);
                }
                return origin.call(this, eventName, fn, options);
            };
        })();
    });
    return function () { return (enabled = false); };
};
//# sourceMappingURL=capture-global.js.map